/* NOVELA — Makeover: offer block (bundles + add to cart + sticky bar) and the
   MSDS section. The cart itself is the NV drawer that ships with the theme
   (window.NVCart from nv-pdp.js, with its own fetch bridge) — this file only
   adds items and asks that drawer to refresh/open. */
(function () {
  'use strict';

  var MONEY = '₪{{amount}}';

  function money(cents) {
    var n = (cents || 0) / 100;
    return MONEY
      .replace(/\{\{\s*amount\s*\}\}/g, n.toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(n).toString())
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, n.toFixed(2));
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
    });
  }
  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function fresh(el) {
    if (!el || el.dataset.nvReady === '1') return false;
    el.dataset.nvReady = '1';
    return true;
  }

  /* Whichever cart drawer the page has: the NV drawer (theme) first,
     then Shrine's own, then the cart page. */
  function showCart() {
    var D = window.NVCart;
    if (D && D.el) {
      var p = D.refresh();
      if (p && p.then) return p.then(function () { D.open(); });
      D.open();
      return Promise.resolve();
    }
    var sh = document.querySelector('cart-drawer');
    if (sh && typeof sh.open === 'function') {
      return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) {
        if (typeof sh.renderContents === 'function') sh.renderContents({ sections: sections });
        else sh.open();
      }).catch(function () { sh.open(); });
    }
    window.location.href = '/cart';
    return Promise.resolve();
  }

  /* items: [{id, quantity, gift?, parent?}] — gifts are skipped when already in
     the cart, and carry a hidden property naming the paid variant they belong to. */
  function addItems(items) {
    return getCart().then(function (cart) {
      var have = {};
      cart.items.forEach(function (it) { have[it.variant_id] = true; });
      var send = items.filter(function (i) { return !(i.gift && have[i.id]); })
        .map(function (i) {
          var line = { id: i.id, quantity: i.quantity || 1 };
          if (i.gift && i.parent) line.properties = { _nv_gift_for: String(i.parent) };
          return line;
        });
      if (!send.length) return cart;
      return post('/cart/add.js', { items: send });
    });
  }

  /* ---- gift guard ----
     A ₪0 gift line must never outlive the paid item it came with: the moment
     the pen leaves the cart its gifts go too, and a cart holding only gifts is
     emptied — otherwise the customer can check out for ₪0. Runs after every
     render of the NV drawer (which the theme's cart bridge triggers on every
     cart change from anywhere). */
  var guardBusy = false;
  function guardGifts(cart) {
    if (!cart || !cart.items || guardBusy) return Promise.resolve(cart);
    var paidVariants = {}, anyPaid = false;
    cart.items.forEach(function (it) {
      if (it.final_line_price > 0 || it.price > 0) { paidVariants[it.variant_id] = true; anyPaid = true; }
    });
    var updates = {}, need = false;
    cart.items.forEach(function (it) {
      var free = it.final_line_price === 0 && it.price === 0;
      if (!free) return;
      var parent = it.properties && it.properties._nv_gift_for;
      if (!anyPaid || (parent && !paidVariants[Number(parent)])) { updates[it.key] = 0; need = true; }
      else if (it.quantity > 1) { updates[it.key] = 1; need = true; }
    });
    if (!need) return Promise.resolve(cart);
    guardBusy = true;
    return post('/cart/update.js', { updates: updates })
      .then(function (c) { guardBusy = false; return c; })
      .catch(function () { guardBusy = false; return cart; });
  }
  function hookDrawer() {
    var D = window.NVCart;
    if (!D || D.__nvGuard || typeof D.render !== 'function') return;
    D.__nvGuard = true;
    var render = D.render;
    D.render = function (cart) {
      var out = render.apply(this, arguments);
      var self = this;
      guardGifts(cart).then(function (c) {
        if (c && c !== cart && !guardBusy) render.call(self, c);
      });
      return out;
    };
    /* the checkout link is useless on a ₪0 cart — the guard empties it, but
       never let the button lead anywhere in the meantime */
    var co = D.el && D.el.querySelector('.nv-co');
    if (co) co.addEventListener('click', function (e) {
      var sum = D.el.querySelector('[data-nv-cd-sum]');
      if (sum && /^\D*0(\.00)?\D*$/.test(sum.textContent.trim())) e.preventDefault();
    });
  }

  /* =====================================================================
     OFFER BLOCK
     ===================================================================== */
  function initOffer(root) {
    if (!fresh(root)) return;
    if (root.dataset.money) MONEY = root.dataset.money;

    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-nvo-variants]') || {}).textContent || '[]'); } catch (e) {}
    var gifts = [];
    try { gifts = JSON.parse(root.dataset.gifts || '[]'); } catch (e) {}
    var labels = {};
    try { labels = JSON.parse(root.dataset.labels || '{}'); } catch (e) {}

    var state = { variant: Number(root.dataset.variant) || 0, qty: 1, net: 0, was: 0, label: '', available: root.dataset.available !== 'false' };
    var tiers = [].slice.call(root.querySelectorAll('[data-nvo-tier]'));
    var atcs = [].slice.call(document.querySelectorAll('[data-nvo-atc="' + root.dataset.nvo + '"]'));
    var sticky = document.querySelector('[data-nvo-sticky="' + root.dataset.nvo + '"]');
    /* position:fixed dies inside Shrine's animated section wrappers */
    if (sticky && sticky.parentNode !== document.body) document.body.appendChild(sticky);
    var err = root.querySelector('[data-nvo-err]');
    var note = root.querySelector('[data-nvo-desc]');

    function paint(pop) {
      atcs.forEach(function (b) {
        var p = b.querySelector('[data-nvo-price]');
        if (p) {
          p.textContent = money(state.net);
          p.hidden = state.net <= 0;
          if (pop) { p.classList.remove('is-pop'); void p.offsetWidth; p.classList.add('is-pop'); }
        }
        var l = b.querySelector('[data-nvo-atc-label]');
        if (l) l.textContent = state.available ? (labels.atc || 'הוספה לעגלה') : (labels.soldout || 'אזל מהמלאי');
        b.disabled = !state.available;
      });
      var save = root.querySelector('[data-nvo-save]');
      if (save) {
        var diff = state.was - state.net;
        save.hidden = diff <= 0 || root.dataset.showSave === 'false';
        save.textContent = (labels.save || 'חסכת [amount] במארז הזה').replace('[amount]', money(diff));
      }
      if (sticky) {
        var st = sticky.querySelector('[data-nvo-sticky-tier]');
        var sp = sticky.querySelector('[data-nvo-sticky-price]');
        if (st) st.textContent = state.label || '';
        if (sp) sp.innerHTML = '<b>' + money(state.net) + '</b>' + (state.was > state.net ? ' <s>' + money(state.was) + '</s>' : '');
      }
    }

    function select(btn, pop) {
      tiers.forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      state.qty = parseInt(btn.dataset.qty, 10) || 1;
      state.net = parseInt(btn.dataset.net, 10) || 0;
      state.was = parseInt(btn.dataset.was, 10) || 0;
      state.label = btn.dataset.label || '';
      if (note) note.textContent = btn.dataset.desc || '';
      paint(pop);
    }
    tiers.forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function () { select(b, true); });
      b.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(b, true); }
      });
    });
    if (tiers.length) select(root.querySelector('[data-nvo-tier][aria-checked="true"]') || tiers[0], false);

    /* ---- variants: our own pills, or Shrine's picker elsewhere on the page */
    function applyVariant(v) {
      if (!v) return;
      state.variant = v.id;
      state.available = !!v.available;
      tiers.forEach(function (b) {
        if (b.dataset.fixed === '1') return;
        var q = parseInt(b.dataset.qty, 10) || 1;
        b.dataset.net = String(v.price * q);
        var cmp = v.compare && (v.compare - v.price) >= 100 ? v.compare : 0;
        b.dataset.was = String(cmp ? cmp * q : 0);
        var now = b.querySelector('[data-nvo-now]'); if (now) now.textContent = money(v.price * q);
        var was = b.querySelector('[data-nvo-was]'); if (was) { was.hidden = !cmp; was.textContent = cmp ? money(cmp * q) : ''; }
      });
      var cur = root.querySelector('[data-nvo-tier][aria-checked="true"]');
      if (cur) select(cur, false); else paint(false);
      root.querySelectorAll('[data-nvo-var]').forEach(function (p) { p.setAttribute('aria-checked', String(Number(p.dataset.id) === v.id)); });
    }
    function byId(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
    root.querySelectorAll('[data-nvo-var]').forEach(function (p) {
      p.addEventListener('click', function () {
        var v = byId(Number(p.dataset.id));
        if (!v) return;
        applyVariant(v);
        try {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch (e) {}
      });
    });
    document.addEventListener('change', function (e) {
      var wrap = e.target.closest('variant-radios, variant-selects, variant-picker, .product-form__input');
      if (!wrap || root.contains(wrap) || variants.length < 2) return;
      var picker = wrap.closest('variant-radios, variant-selects, variant-picker') || wrap;
      var vals = [];
      picker.querySelectorAll('fieldset, .product-form__input').forEach(function (f) {
        var r = f.querySelector('input[type="radio"]:checked');
        var s = f.querySelector('select');
        if (r) vals.push(r.value); else if (s) vals.push(s.value);
      });
      if (!vals.length) return;
      var hit = variants.filter(function (v) {
        return vals.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (hit) applyVariant(hit);
    });
    try {
      var qv = Number(new URL(window.location.href).searchParams.get('variant'));
      if (qv && byId(qv)) applyVariant(byId(qv));
    } catch (e) {}

    /* ---- add to cart */
    function selectedUpsells() {
      var out = [];
      document.querySelectorAll('product-info-upsell[data-toggle="true"]').forEach(function (u) {
        var on = u.getAttribute('data-selected') === 'true' || /(^|\s)(selected|is-selected|active|upsell--selected)(\s|$)/.test(u.className) ||
                 !!u.querySelector('.toggle-switch.active, .toggle-switch--active, [aria-pressed="true"]');
        var id = Number(u.dataset.id);
        if (on && id) out.push({ id: id, quantity: 1 });
      });
      return out;
    }
    function add() {
      if (!state.variant || !state.available) return;
      if (err) err.classList.remove('is-on');
      var items = [{ id: state.variant, quantity: state.qty }].concat(selectedUpsells());
      gifts.forEach(function (g) { if (g && g.id) items.push({ id: Number(g.id), quantity: 1, gift: true, parent: state.variant }); });
      atcs.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
      var done = function () { atcs.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = !state.available; }); };
      addItems(items)
        .then(function () { return showCart(); })
        .then(done)
        .catch(function (e) {
          done();
          if (err) {
            err.textContent = (e && (e.description || e.message)) || (labels.err || 'משהו השתבש, נסי שוב');
            err.classList.add('is-on');
          }
        });
    }
    atcs.forEach(function (b) { b.addEventListener('click', add); });

    /* ---- sticky bar: shows once the main button has scrolled out above */
    if (sticky && atcs[0] && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        document.documentElement.classList.toggle('nvo-has-sticky', on);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(atcs[0]);
    }
  }

  /* =====================================================================
     MSDS SECTION — bars animate in, the document opens in a lightbox
     ===================================================================== */
  function initMsds(s) {
    if (!fresh(s)) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { s.classList.add('is-in'); io.disconnect(); }
      }, { threshold: 0.15 });
      io.observe(s);
    } else { s.classList.add('is-in'); }

    /* the whole report opens in an in-page viewer (every page, sharp, scrollable), so the
       shopper never leaves the product page; the page images load only on first open */
    var lb = s.querySelector('[data-nvm-lb]');
    if (!lb) return;
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    var scroller = lb.querySelector('[data-nvm-lb-scroll]'), hydrated = false, lastFocus = null;
    function loadImg(im) {
      if (!im || !im.dataset.src) return;
      var fig = im.closest('.nvm__lb-pg');
      im.addEventListener('load', function () { if (fig) fig.classList.add('is-loaded'); }, { once: true });
      if (im.dataset.srcset) im.setAttribute('srcset', im.dataset.srcset);
      im.src = im.dataset.src; delete im.dataset.src;
    }
    /* pages load one at a time as they come into view inside the viewer (not all 11 at once) */
    function hydrate(page) {
      var imgs = lb.querySelectorAll('img[data-src]');
      if (!imgs.length) return;
      if (!hydrated) {
        hydrated = true;
        if ('IntersectionObserver' in window && scroller) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { loadImg(en.target); io.unobserve(en.target); } });
          }, { root: scroller, rootMargin: '120% 0px' });
          imgs.forEach(function (im) { io.observe(im); });
        } else {
          imgs.forEach(loadImg);
        }
      }
      var first = lb.querySelector('[data-nvm-pg="' + page + '"] img[data-src]');
      if (first) loadImg(first);
    }
    function open(page) {
      hydrate(page);
      lastFocus = document.activeElement;
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var pg = scroller && scroller.querySelector('[data-nvm-pg="' + page + '"]');
      if (scroller) scroller.scrollTop = pg ? Math.max(0, pg.offsetTop - 8) : 0;
      var x = lb.querySelector('[data-nvm-lb-close]'); if (x) x.focus();
    }
    function close() {
      lb.classList.remove('is-open'); document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    s.addEventListener('click', function (e) {
      var z = e.target.closest('[data-nvm-open]');
      if (!z) return;
      e.preventDefault();
      open(parseInt(z.getAttribute('data-nvm-open'), 10) || 1);
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-nvm-lb-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
  }

  /* Sections below the fold rise softly into view as they are scrolled to (the calm reveal
     Mayven-style stores use). Sections with sticky/fixed parts, drawers, bars and the
     sections that animate themselves are left alone; nothing above the fold is delayed. */
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var vh = window.innerHeight, list = [];
    var skip = /sticky|fixed|popup|modal|drawer|announcement|header|footer|bar|cart|newsletter|scroll-to-top|back-to-top/i;
    Array.prototype.forEach.call(main.querySelectorAll('.shopify-section'), function (sec) {
      if (skip.test(sec.id) || skip.test(sec.className)) return;
      if (sec.querySelector('[data-nvs], [data-nvo], [data-nvm], [data-nvi], [data-nvb], [data-nv-sticky], .nv-sticky, cart-drawer, sticky-add-to-cart, .sticky-atc')) return;
      var r = sec.getBoundingClientRect();
      if (r.height < 40 || r.top < vh * 0.85) return;
      var kids = sec.children, ok = true;
      for (var i = 0; i < kids.length; i++) {
        var cs = getComputedStyle(kids[i]);
        if (cs.position === 'fixed' || cs.position === 'sticky') { ok = false; break; }
      }
      if (!ok) return;
      sec.classList.add('nv-rv'); list.push(sec);
    });
    if (!list.length) return;
    document.documentElement.classList.add('nv-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('nv-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    list.forEach(function (sec) { io.observe(sec); });
    /* safety net: whatever is still hidden after 8 s (odd layouts, print) shows up */
    setTimeout(function () { list.forEach(function (sec) { sec.classList.add('nv-in'); }); }, 8000);
  }

  /* Phone, pen page: the gallery is pinned (CSS) and eases back while the info sheet covers it. */
  function penHero() {
    if (!document.querySelector('[data-nvs]')) return;
    document.documentElement.classList.add('nv-pen');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    var wrap = document.querySelector('.product__media-wrapper'), gal = wrap && wrap.querySelector('media-gallery');
    if (!wrap || !gal || !mq) return;
    var raf = 0;
    function tick() {
      raf = 0;
      if (!mq.matches) { gal.style.transform = ''; gal.style.opacity = ''; return; }
      var h = wrap.offsetHeight || 1, p = Math.max(0, Math.min(1, window.scrollY / h));
      gal.style.transform = 'scale(' + (1 - p * 0.08).toFixed(4) + ')';
      gal.style.opacity = (1 - p * 0.45).toFixed(3);
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tick();
  }

  function boot() {
    document.querySelectorAll('[data-nvo]').forEach(initOffer);
    document.querySelectorAll('[data-nvm]').forEach(initMsds);
    hookDrawer();
    try { reveal(); } catch (e) {}
    try { penHero(); } catch (e) {}
    /* nv-pdp.js is deferred too and may boot after us */
    if (!window.NVCart) setTimeout(hookDrawer, 400);
    if (window.NVCart && window.NVCart.el) getCart().then(guardGifts).then(function (c) { if (c && window.NVCart.render) window.NVCart.render(c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
